import React, { useEffect, useState } from "react";
import { PAN_AADHAAR_VERIFICATION_STATUS } from "../../constants";

function CustomerKYCDetails() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null); // start with null instead of []
  const [aadhaarState, setAadhaarState] = useState(null);

  const getPanAadhaarVerificationStatus = async () => {
    try {
      const leadId = JSON.parse(localStorage.getItem("eKYCData"));

      if (!leadId?.lead_id) {
        console.error("Lead ID not found in localStorage");
        return;
      }

      setLoading(true);

      const apiUrl = `${PAN_AADHAAR_VERIFICATION_STATUS}/${leadId.lead_id}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        setAadhaarState(data?.data?.checkVerification?.aadhaarVerification || null);
        setFormData(data?.data?.aadhaarDetails || null); // set to null if not present
      } else {
        console.error("Error from API:", data);
        setFormData(null);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setFormData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPanAadhaarVerificationStatus();
    console.log("running.......");
  }, []);

  return (
    <div>
      <div className="bg-white border border-gray-200 rounded-lg p-7 sm:p-6 space-y-4">
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : formData ? (
          <>
            <h4 className="font-semibold text-gray-900 mb-4">
              Verified Information: Aadhaar Card
            </h4>

            {/* Passport Photo */}
            <div className="flex justify-center mb-4">
              <img
                src={
                  formData.photo ||
                  "https://via.placeholder.com/150x200?text=No+Photo"
                }
                alt="Passport Photo"
                className="w-32 h-40 object-cover rounded-lg border border-gray-300 shadow-sm"
              />
            </div>

            <div className="grid grid-cols-1 gap-4 sm:gap-6">
              <div className="space-y-3">
                <div>
                  <span className="text-sm font-medium text-gray-600">Name:</span>
                  <p className="text-sm font-semibold break-words">
                    {formData.name}
                  </p>
                </div>

                <div>
                  <span className="text-sm font-medium text-gray-600">
                    Father's Name:
                  </span>
                  <p className="text-sm break-words">{formData.fatherName}</p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm font-medium text-gray-600">
                      Date of Birth:
                    </span>
                    <p className="text-sm">{formData.dateOfBirth}</p>
                  </div>

                  <div>
                    <span className="text-sm font-medium text-gray-600">
                      Gender:
                    </span>
                    <p className="text-sm">{formData.gender}</p>
                  </div>
                </div>

                <div>
                  <span className="text-sm font-medium text-gray-600">
                    Address:
                  </span>
                  <p className="text-sm break-words">{formData.address}</p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm font-medium text-gray-600">
                      PIN Code:
                    </span>
                    <p className="text-sm">{formData.pincode}</p>
                  </div>

                  <div>
                    <span className="text-sm font-medium text-gray-600">
                      Mobile:
                    </span>
                    <p className="text-sm">+91 {formData.mobileNumber}</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <p className="text-center text-gray-500">No data available</p>
        )}
      </div>
    </div>
  );
}

export default CustomerKYCDetails;
